// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"io-z","badgeLink":"jo-z","category":"ko-z"};